<template>
    <div :class="cardClasses" class="layout-expanding-hover-card">
        <LayoutCard
            :route="route"
            :image="image"
            :imageAlt="imageAlt"
            :heading="heading"
            :excerpt="excerptOnlyOnHover ? null : excerpt"
            :imageAspectRatio="imageAspectRatio"
            :imageObjectFit="imageObjectFit"
            :imageObjectPosition="imageObjectPosition"
            :imageOverlayLocked="imageOverlayLocked"
            :imageLoading="imageLoading"
            :fetchPriority="fetchPriority"
            :dark="dark"
        />
        <LayoutHoverCard
            class="absolute top-0 left-0 w-full transition-all duration-300 transform opacity-0 -z-10 delay-[400ms] group-hover:opacity-100 group-hover:scale-110 group-hover:z-10 shadow-2xl shadow-black"
            :route="route"
            :image="image"
            :imageAlt="imageAlt"
            :heading="heading"
            :excerpt="excerpt"
            :imageAspectRatio="imageAspectRatio"
            :imageObjectFit="imageObjectFit"
            :imageObjectPosition="imageObjectPosition"
            :imageOverlayLocked="imageOverlayLocked"
            :imageLoading="imageLoading"
            :fetchPriority="fetchPriority"
            :dark="dark"
            :content="content"
            :buttonText="buttonText"
        />
    </div>
</template>

<script>

export default {
    name: 'LayoutExpandingHoverCard',
    props: {
        route: {
            required: false,
            type: [String, Object],
            default: null,
        },
        href: {
            required: false,
            type: String,
        },
        target: {
            required: false,
            type: String,
            default: null,
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'p',
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
        imageAspectRatio: {
            required: false,
            type: String,
            default: null,
        },
        imageObjectFit: {
            required: false,
            type: String,
            default: 'object-cover',
        },
        imageObjectPosition: {
            required: false,
            type: String,
            default: 'center',
        },
        imageOverlayLocked: {
            required: false,
            type: [Boolean, Number],
            default: null,
        },
        imageLoading: {
            required: false,
            type: String,
            default: undefined,
        },
        fetchPriority: {
            required: false,
            type: [String, undefined],
            default: undefined,
        },
        dark: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonText: {
            required: false,
            type: String,
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
        excerptOnlyOnHover: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        bindings () {
            const bindings = {};
            if (this.route) bindings.to = this.route;
            if (this.href) bindings.href = this.href;
            return bindings;
        },
        cardClasses () {
            const cls = {};
            cls['col-span-1 flex flex-col divide-y LayoutExpandingHoverCard relative group'] = true;
            cls['text-center'] = !!this.textCentered;
            return cls;
        },
    },
};
</script>
